import React from 'react';
import {
  Badge,
  Button,
  Link,
  Popconfirm,
  Space,
  Switch,
  Tag,
  Tooltip,
  Typography,
} from '@arco-design/web-react';
import PermissionWrapper from '@/components/PermissionWrapper';
import { ColumnProps } from '@arco-design/web-react/es/Table';

export const VectorStatusPending = 1; // 状态：待处理
export const VectorStatusQueue = 2; // 状态：排队中
export const VectorStatusProcessing = 3; // 状态：处理中
export const VectorStatusCompleted = 4; // 状态：已完成
export const VectorStatusFailed = 5; // 状态：处理失败

export const VectorTypeMedicalTest = 1; // 类型：医学检查项目
export const VectorTypeBodyPart = 2; // 类型：身体物质/部位

export const VectorStatusList = [
  {
    label: '待处理',
    value: VectorStatusPending,
  },
  {
    label: '排队中',
    value: VectorStatusQueue,
    color: '#faad14',
  },
  {
    label: '处理中',
    value: VectorStatusProcessing,
    color: 'arcoblue',
  },
  {
    label: '已完成',
    value: VectorStatusCompleted,
    color: '#52c41a',
  },
  {
    label: '失败',
    value: VectorStatusFailed,
    color: '#f50',
  },
];
export const VectorTypeList = [
  {
    label: '医学检查项目',
    value: VectorTypeMedicalTest,
  },
  {
    label: '身体物质/部位',
    value: VectorTypeBodyPart,
    color: '#faad14',
  },
];
export function getColumns(
  callback: (record: Record<string, any>, type: string) => Promise<void>
) {
  const columns: ColumnProps[] = [
    {
      title: '#',
      dataIndex: 'id',
      width: 60,
      align: 'center',
    },
    {
      title: '名称',
      dataIndex: 'name',
      width: 200,
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      width: 100,
      render: (x, record) => {
        const currentStatus = VectorStatusList.find((item) => item.value === x);
        return (
          <Tag color={currentStatus?.color || '#999999'}>
            {currentStatus?.label || '未知'}
          </Tag>
        );
      },
    },
    {
      title: '类型',
      dataIndex: 'type',
      align: 'center',
      width: 100,
      render: (x, record) => {
        const currentStatus = VectorTypeList.find((item) => item.value === x);
        return (
          <Tag color={x === VectorTypeMedicalTest ? 'arcoblue' : ''}>
            {currentStatus?.label || '未知'}
          </Tag>
        );
      },
    },
    {
      title: '是否别名',
      dataIndex: 'isAlias',
      width: 100,
      align: 'center',
      render: (x, record) => {
        return x === 1 ? <Tag color="arcoblue">是</Tag> : <Tag>否</Tag>;
      },
    },
    {
      title: '图谱ID',
      dataIndex: 'graphId',
      width: 250,
      render: (x, record) => (
        <Typography.Text ellipsis copyable>
          {x}
        </Typography.Text>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      align: 'center',
      width: 170,
      render: (x, record) => {
        return x ? new Date(x).toLocaleString() : '-';
      },
    },
    // {
    //   title: '操作',
    //   dataIndex: 'operations',
    //   fixed: 'right',
    //   align: 'center',
    //   width: 240,
    //   headerCellStyle: { paddingLeft: '15px' },
    //   render: (_, record) => (
    //     <Space>
    //       <PermissionWrapper requiredPermissions={[]}>
    //         <Button
    //           type="text"
    //           size="small"
    //           onClick={() => callback(record, 'delete')}
    //         >
    //           删除
    //         </Button>
    //       </PermissionWrapper>
    //     </Space>
    //   ),
    // },
  ];
  return columns;
}
